// Layout
import Layout from 'components/layout/Layout';

import EditComposerModal from "components/modal/EditComposerModal";
import EditOeuvreModal from "components/modal/EditOeuvreModal";

import ShowComposer from "components/modal/ShowComposer";
import ShowHelpModal from "components/modal/ShowHelpModal";

import Select from 'react-select';
import { useAuth } from 'hooks/auth';
import axios from 'utils/axios';
import cn from "classnames";
import usePrevious from 'hooks/usePrevious';
import {
  optionOriginal,
  level,
  type,
  genderFilters,
  fieldFilters
} from "constants/data-filter";

// Common
import ButtonAction from "components/common/filters/button-action";
import ButtonField from "components/common/filters/button-field";
import HeaderSearch from "components/common/header-search";
import HeaderDesktopFilters from "components/common/filters/header-desktop";
import HeaderMobileFilters from "components/common/filters/header-mobile";
import TopHeader from "components/common/top-header";

// UI
import { Slider } from "components/ui/Slider";
import ButtonEvent from "components/ui/button-event";
import Label from "components/ui/Label";
import Container from "components/ui/container";
import ValidateButton from "components/ui/validate-button";

// Collection
import DisplayComposer from "components/collection/display-composer";
import DisplayWork from "components/collection/display-work";
import React, { useState, useEffect, useRef, useCallback, Fragment } from "react";

// SEO SETINGS
import {
  formatWorksScript,
  formatComposersScript
} from "lib/seo.settings";

import { API_ENDPOINTS } from "utils/api-endpoints";

const minValue = 1600;
const maxValue = 2022;

const activeWorkMenu = 1;
const activeComposerMenu = 2;

export default function Search() {

  const minRef = useRef(null);
  const maxRef = useRef(null);

  const minDurationRef = useRef(null);
  const maxDurationRef = useRef(null);

  const minBirthRef = useRef(null);
  const maxBirthRef = useRef(null);

  const ref = useRef(null);
  const filterRef = useRef(null);
  const titleRef = useRef();

  const { user } = useAuth();

  const [minDateOfComposition, setMinDateOfComposition] = useState(1600);
  const [maxDateOfComposition, setMaxDateOfComposition] = useState(2022);

  const [minDateOfBirth, setMinDateOfBirth] = useState(minValue);
  const [maxDateOfBirth, setMaxDateOfBirth] = useState(maxValue);

  const [minDuration, setMinDuration] = useState(0);
  const [maxDuration, setMaxDuration] = useState(120);

  // Initial state
  const [allWorks, setAllWorks] = useState([]),
    [allComposers, setAllComposers] = useState([]);

  const [showMobileFilter, setShowMobileFilter] = useState(false);

  const [openEditComposerModal, setOpenEditComposerModal] = useState(false),
    [openEditOeuvreModal, setOpenEditOeuvreModal] = useState(false),
    [openLoginModal, setOpenLoginModal] = useState(false),
    [openShowComposer, setOpenShowComposer] = useState(false),
    [openShowHelp, setOpenShowHelp] = useState(false);

  // State sidebar
  const [showFilters, setShowFilter] = useState(false),
    [showPopover, setShowPopover] = useState(false),
    [isMenuActive, setIsMenuActive] = useState(null),
    [isClickedBtn, setIsClickedBtn] = useState(1);

  const [filter, setFilter] = useState({
    // typeOfCard: null,
    typeOfFirstCard: null,
    typeOfSecondCard: null,
    greatRepertoire: null,
    concerto: null,
    duration: null,
    originalTranscription: null,
    dateOfComposition: null,
    dateOfPublication: null,
    contemporainMusic: null,
    typeChoosen: null,
    level: null,
    nationality: null,
    perfomedAtRppf: null,
    //composers filter
    dateOfBirth: null,
    dateOfDeath: null,
    gender: "All"
  });

  const [action, setAction] = useState({
    greatRepertoire: false,
    method: false,
    concerto: false,
    compilation: false,
    perfomedAtRppf: false,
    contemporainMusic: false,
  });

  const [works, setWorks] = useState([]),
    [composers, setComposers] = useState([]),
    [oeuvreToEdit, setOeuvreToEdit] = useState([]),
    [composerToEdit, setComposerToEdit] = useState([]),
    [composerToShow, setComposerToShow] = useState([]),
    [helpToShow, setHelpToShow] = useState({
      title: '',
      text: ''
    }),
    [allCountrie, setAllCountrie] = useState([]),
    // Loading state
    [isLoadingWork, setIsLoadingWork] = useState(false),
    [isLoadingComposer, setIsLoadingComposer] = useState(false);

  // Action more state
  const [searchedArrayComposer, setSearchedArrayComposer] = useState([]),
    [searchedArrayWork, setSearchedArrayWork] = useState([]),
    [searchString, setSearchString] = useState("");

  const prevFilter = usePrevious(filter);
  const prevAction = usePrevious(action);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getCountry();
      getListWorks();
      getListComposers();
    }
    return () => {
      mounted = false;
    }
  }, []);

  useEffect(() => {
    let mounted = true;
    if ((prevFilter && prevFilter !== filter) || (prevAction && prevAction !== action)) {
      if (isClickedBtn === activeWorkMenu) {
        setIsLoadingWork(true);
      } else {
        setIsLoadingComposer(true);
      }
      if (mounted) {
        getDataByFilter(filter);
      }
    }
    return () => {
      mounted = false;
    }
  }, [action, filter]);

  useEffect(() => {
    const queryString = window?.location.search;
    const data = queryString.split("_");
    const composerId = parseInt(data[1]);
    if (composerId !== undefined && composerId > 0) {
      handleShowComposer(composerId);
    }
    return () => {
      handleShowComposer(null);
    }
  }, [allComposers]);

  useEffect(() => {
    if (isClickedBtn === activeWorkMenu) {
      getWorkData();
      setIsMenuActive(1);
    } else {
      getComposerData();
      setIsMenuActive(2);
    }
  }, [isClickedBtn])


  useEffect(() => {
    const checkIfClickedOutside = e => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (showPopover && ref.current && !ref.current.contains(e.target)) {
        setShowPopover(false);
      }

      if (showFilters && filterRef.current && !filterRef.current.contains(e.target)) {
        setShowFilter(false);
      }
    }

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    }
  }, [showPopover, showFilters]);


  const getCountry = () => {
    axios.get(API_ENDPOINTS.NATIONALTY).then(res => setAllCountrie(res.data.data))
  }

  const getWorkData = () => {
    setIsLoadingWork(true);
    axios.get(API_ENDPOINTS.GET_WORKS).then((res) => {
      setWorks(res.data.data);
      setIsLoadingWork(false);
    });
  }

  const getComposerData = () => {
    setIsLoadingComposer(true);
    axios.get(API_ENDPOINTS.GET_COMPOSERS).then((res) => {
      setComposers(res.data.data);
      setIsLoadingComposer(false);
    });
  }

  const getListWorks = () => {
    axios.get(API_ENDPOINTS.GET_ALL_WORKS).then((res) => {
      formatWorksScript(res.data.data); //Set updated data to head 
      setAllWorks(res.data.data);
    })
  }

  const getListComposers = () => {
    axios.get(API_ENDPOINTS.GET_ALL_COMPOSERS).then((res) => {
      formatComposersScript(res.data.data); //Set updated data to head 
      setAllComposers(res.data.data);
    });
  }

  const handleUpdateWork = (id) => {
    const dataClick = allWorks.filter(res => res.id === id);
    setOeuvreToEdit(dataClick[0]);
    if (!user) {
      setOpenLoginModal(true);
    } else {
      setOpenEditOeuvreModal(true);
    }
  }

  const handleShowComposer = useCallback((id) => {
    const dataClick = allComposers.filter(res => res.id === id);
    if (dataClick[0] && dataClick[0] !== undefined) {
      setComposerToShow(dataClick[0]);
      setOpenShowComposer(true);
    }
  }, [allComposers]);

  // Filter searching
  const getDataByFilter = (data) => {
    console.log("filters", data);
    axios.post(`${API_ENDPOINTS.FILTERS}/${isClickedBtn}`, data)
      .then((res) => {
        setIsLoadingWork(false);
        setIsLoadingComposer(false);
        if (isClickedBtn === activeWorkMenu) {
          setWorks(res.data.data)
        } else {
          setComposers(res.data.data)
        }
      }).catch(() => {
        setIsLoadingWork(false);
        setIsLoadingComposer(false);
      })
  }

  const handleButtonAction = (value) => {

    setIsMenuActive(activeWorkMenu);
    setIsLoadingWork(true);

    fieldFilters.forEach(el => {
      if (value === el.nameField) {
        setAction({ ...action, [el.nameField]: true });
        setFilter(() => ({ ...filter, [el.nameField]: 1 }));
      }
    });
  }

  function handleClick() {
    titleRef.current.scrollIntoView({ behavior: "smooth" });
  }

  const handleDisplaySearchResult = () => {

    handleClick();

    if (isClickedBtn === activeWorkMenu) {
      setShowPopover(false);
      const resultWork = {
        data: searchedArrayWork
      };
      setWorks(resultWork);
    } else if (isClickedBtn === activeComposerMenu) {
      setShowPopover(false);
      const resultComposer = {
        data: searchedArrayComposer
      };
      setComposers(resultComposer);
    }
  }

  const handleShowHelp = (title, text) => {
    setHelpToShow({
      ...helpToShow, title: title, text: text
    });
    setOpenShowHelp(true);
  }

  const showButtonField = (data) => {
    return (
      <>
        {Array.isArray(data) && data.map((item, index) => {
          return (
            <ButtonField
              handleCancelClick={() => { setFilter(() => ({ ...filter, [item.nameField]: null })); setAction({ ...action, [item.nameField]: false }) }}
              isClicked={action[item.nameField]}
              id={item.nameField}
              onClick={() => handleButtonAction(item.nameField)}
              showHelp={true}
              key={index}
              help={item.help}
              handleSHow={() => handleShowHelp(item.name, item.help)}
            >
              {item.name}
            </ButtonField>
          )
        })}
      </>
    )
  }

  return (
    <>
      <ShowComposer
        open={openShowComposer}
        setOpen={setOpenShowComposer}
        composerToShow={composerToShow}
        onClose={() => setOpenShowComposer(false)}
      >
      </ShowComposer>

      <ShowHelpModal
        open={openShowHelp}
        setOpen={setOpenShowHelp}
        helpToShow={helpToShow}
        onClose={() => setOpenShowHelp(false)}
      >
      </ShowHelpModal>

      <EditComposerModal
        open={openEditComposerModal}
        setOpen={setOpenEditComposerModal}
        composerToEdit={composerToEdit}
        onClose={() => setOpenEditComposerModal(false)}
      >
      </EditComposerModal>

      <EditOeuvreModal
        open={openEditOeuvreModal}
        setOpen={setOpenEditOeuvreModal}
        oeuvreToEdit={oeuvreToEdit}
        onClose={() => setOpenEditOeuvreModal(false)}
      >
      </EditOeuvreModal>

      <Layout pageTitle="Search results">
        <HeaderSearch
          showPopover={showPopover}
          handleDisplaySearchResult={() => handleDisplaySearchResult()}
          setShowPopover={setShowPopover}
          setSearchString={setSearchString}
          searchedArrayWork={searchedArrayWork}
          searchedArrayComposer={searchedArrayComposer}
          isClickedBtn={isClickedBtn}
          searchString={searchString}
          setIsClickedBtn={setIsClickedBtn}
          hearderRef={ref}
          setSearchedArrayComposer={setSearchedArrayComposer}
          setSearchedArrayWork={setSearchedArrayWork}
          allComposers={allComposers}
          allWorks={allWorks}
          activeComposerMenu={activeComposerMenu}
          activeWorkMenu={activeWorkMenu}
        />

        <div
          id="bloc"
          ref={titleRef}
          className={cn(
            showMobileFilter ? 'flex-col' : '',
            "flex flex-row w-full"
          )}
        >
          {/* Start left sidebar */}
          <div
            className={cn(
              showMobileFilter ? 'block' : 'hidden lg:block',
              " w-full lg:w-2/6 xl:w-1/4 h-full sticky top-0 shadow-2xl"
            )}
          >
            {/* Header filter */}
            <TopHeader
              setShowFilter={setShowFilter}
              setShowMobileFilter={setShowMobileFilter}
              showMobileFilter={showMobileFilter}
              showFilters={showFilters}
            />

            <div className="h-screen pb-36 overflow-y-auto md:px-3 px-4 space-y-8 -pt-4">
              <HeaderMobileFilters
                isMenuActive={isMenuActive}
                isClickedBtn={isClickedBtn}
                totalComposers={composers?.total}
                totalWorks={works?.total}
              >
                {showButtonField(fieldFilters)}
              </HeaderMobileFilters>

              <Container>
                <Label> Search in {isClickedBtn === activeWorkMenu ? 'works' : 'composers'} </Label>
                <div className="flex flex-row space-x-4">
                  <ButtonEvent
                    typeEvent={"Works"}
                    valueEvent={activeWorkMenu}
                    isClickedBtn={isClickedBtn}
                    setIsClickedBtn={setIsClickedBtn}
                  />
                  <ButtonEvent
                    typeEvent={"Composers"}
                    valueEvent={activeComposerMenu}
                    isClickedBtn={isClickedBtn}
                    setIsClickedBtn={setIsClickedBtn}
                  />
                </div>
              </Container>

              {isClickedBtn === activeWorkMenu &&
                <Fragment>
                  <Container>
                    <Label> Formation </Label>
                    <div className="flex flex-col">
                      <Select
                        options={type}
                        isClearable={() => setFilter({ ...filter, typeChoosen: null })}
                        onChange={(e) => setFilter({ ...filter, typeChoosen: e?.value })}
                      />
                    </div>
                  </Container>

                  <Container>
                    <Label> Nationality </Label>
                    <div className="flex flex-col">
                      <Select
                        options={allCountrie}
                        isClearable={() => setFilter({ ...filter, nationality: null })}
                        getOptionLabel={option => `${option.countries}`}
                        getOptionValue={option => `${option.countries}`}
                        onChange={(e) => setFilter({ ...filter, nationality: e?.countries })}
                      />
                    </div>
                  </Container>

                  <Container>
                    <Label> Gender </Label>
                    <div className="grid gap-4 grid-cols-2">
                      {genderFilters.map((item, index) => (
                        <ButtonAction
                          item={item}
                          key={index}
                          type={filter.gender}
                          onClick={() => setFilter({ ...filter, gender: item.value })}
                        />
                      ))}
                    </div>
                  </Container>

                  <Container>
                    <Label> Original / Transcription</Label>
                    <div className="grid gap-2 grid-cols-2">
                      {optionOriginal.map((item, index) => (
                        <ButtonAction
                          item={item}
                          key={index}
                          type={filter.originalTranscription}
                          onClick={() => setFilter({ ...filter, originalTranscription: item.value })}
                        />
                      ))}
                    </div>
                  </Container>

                  <Container>
                    <Label> Level </Label>
                    <div className="grid gap-4 grid-cols-2">
                      {level.map((item, index) => (
                        <ButtonAction
                          item={item}
                          key={index}
                          type={filter.level}
                          onClick={() => setFilter({ ...filter, level: item.value })}
                        />
                      ))}
                    </div>
                  </Container>

                  <Container>
                    <Label> Date of composition </Label>
                    <div className="flex flex-col">
                      <Slider
                        handleSetMin={(e) => setMinDateOfComposition(parseInt(e.target.value))}
                        handleSetMax={(e) => setMaxDateOfComposition(parseInt(e.target.value))}
                        minValue={minValue}
                        maxValue={maxValue}
                        minTypeField={minDateOfComposition}
                        maxTypeField={maxDateOfComposition}
                        maxRef={maxRef}
                        minRef={minRef}
                      />
                      <ValidateButton onClick={() => setFilter({ ...filter, dateOfComposition: [minDateOfComposition, maxDateOfComposition] })} />
                    </div>
                  </Container>

                  <Container>
                    <Label> Duration (min)</Label>
                    <div className="flex flex-col">
                      <Slider
                        handleSetMin={(e) => setMinDuration(parseInt(e.target.value))}
                        handleSetMax={(e) => setMaxDuration(parseInt(e.target.value))}
                        minValue={1}
                        maxValue={120}
                        minTypeField={minDuration}
                        maxTypeField={maxDuration}
                        maxRef={maxDurationRef}
                        minRef={minDurationRef}
                      />
                      <ValidateButton onClick={() => setFilter({ ...filter, duration: [minDuration, maxDuration] })} />
                    </div>
                  </Container>
                </Fragment>
              }

              {isClickedBtn === activeComposerMenu &&
                <Fragment>
                  <Container>
                    <Label> Nationality </Label>
                    <div className="flex flex-col">
                      <Select
                        options={allCountrie}
                        getOptionLabel={option => `${option.countries}`}
                        getOptionValue={option => `${option.countries}`}
                        isClearable={() => setFilter({ ...filter, nationality: null })}
                        onChange={(e) => setFilter({ ...filter, nationality: e?.countries })}
                      />
                    </div>
                  </Container>

                  <Container>
                    <Label> Gender </Label>
                    <div className="grid gap-4 grid-cols-2">
                      {genderFilters.map((item, index) => (
                        <ButtonAction
                          item={item}
                          key={index}
                          type={filter.gender}
                          onClick={() => setFilter({ ...filter, gender: item.value })}
                        />
                      ))}
                    </div>
                  </Container>

                  <Container>
                    <Label> Date of birth </Label>
                    <div className="flex flex-col">
                      <Slider
                        handleSetMin={(e) => setMinDateOfBirth(parseInt(e.target.value))}
                        handleSetMax={(e) => setMaxDateOfBirth(parseInt(e.target.value))}
                        minValue={minValue}
                        maxValue={maxValue}
                        minTypeField={minDateOfBirth}
                        maxTypeField={maxDateOfBirth}
                        maxRef={maxBirthRef}
                        minRef={minBirthRef}
                      />
                      <ValidateButton onClick={() => setFilter({ ...filter, dateOfBirth: [minDateOfBirth, maxDateOfBirth] })} />
                    </div>
                  </Container>
                </Fragment>
              }
            </div>
          </div>
          {/* End left sidebar */}

          {/* Container */}
          <div
            className={cn(
              "w-full lg:w-4/6 xl:w-3/4 space-y-0 md:space-y-6 pt-6 px-4"
            )}
          >
            <HeaderDesktopFilters
              isMenuActive={isMenuActive}
              isClickedBtn={isClickedBtn}
              showMobileFilter={showMobileFilter}
              setShowMobileFilter={setShowMobileFilter}
              totalComposers={composers?.total}
              totalWorks={works?.total}
            >
              {showButtonField(fieldFilters)}
            </HeaderDesktopFilters>

            <Fragment>
              <DisplayWork
                isMenuActive={isMenuActive}
                isClickedBtn={isClickedBtn}
                handleUpdateWork={handleUpdateWork}
                works={works?.data}
                links={works?.links}
                setWorks={setWorks}
                isLoadingWork={isLoadingWork}
                searchString={searchString}
                payload={filter}
              />

              <DisplayComposer
                isMenuActive={isMenuActive}
                isClickedBtn={isClickedBtn}
                handleShowComposer={handleShowComposer}
                composers={composers?.data}
                links={composers?.links}
                setComposers={setComposers}
                isLoadingComposer={isLoadingComposer}
                searchString={searchString}
                payload={filter}
              />
            </Fragment>
          </div>
        </div>
      </Layout>
    </>
  )
}
